var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.31738C12 8.84782 11.7893 9.35652 11.4142 9.7316C11.0391 10.1067 10.5304 10.3174 10 10.3174H8V12.3174H12V14.3174H6V10.3174C6 9.78695 6.21071 9.27824 6.58579 8.90317C6.96086 8.5281 7.46957 8.31738 8 8.31738H10V6.31738H6V4.31738H10C10.5304 4.31738 11.0391 4.5281 11.4142 4.90317C11.7893 5.27824 12 5.78695 12 6.31738V8.31738ZM16 0.317383H2C1.46957 0.317383 0.960859 0.528096 0.585786 0.903169C0.210714 1.27824 0 1.78695 0 2.31738V16.3174C0 16.8478 0.210714 17.3565 0.585786 17.7316C0.960859 18.1067 1.46957 18.3174 2 18.3174H16C16.5304 18.3174 17.0391 18.1067 17.4142 17.7316C17.7893 17.3565 18 16.8478 18 16.3174V2.31738C18 1.78695 17.7893 1.27824 17.4142 0.903169C17.0391 0.528096 16.5304 0.317383 16 0.317383Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepTwo);
export default __webpack_public_path__ + "static/media/step-two.1c332591017c6f532916839dda9d79c5.svg";
export { ForwardRef as ReactComponent };